module.exports = __webpack_public_path__ + "img/selected4-min.ae04c408.png";